export const centsToEuro = cents => {
    return (cents / 100).toFixed(2).toString().replace(".", ",");
}